import BlockSettingsSchema from '@plone/volto/components/manage/Blocks/Block/Schema';
import { OnlyContentTypes } from 'govbr.frontend.policy/helpers/BlockConditions';

import EditBlock from './Edit';
import VideoContentBlockSchema from './schema';
import ViewBlock from './View';

import videoSVG from '@plone/volto/icons/videocamera.svg';

export const applyConfigBlockVideoContent = (config) => {
  config.blocks.blocksConfig.videoContent = {
    id: 'videoContent',
    title: 'Video Content',
    icon: videoSVG,
    group: 'media',
    view: ViewBlock,
    edit: EditBlock,
    schema: BlockSettingsSchema,
    blockSchema: VideoContentBlockSchema,
    restricted: OnlyContentTypes(['Video']),
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  return config;
};
